import type React from 'react'
import type { HTMLAttributes } from 'react'

import { Text } from '@moment/auth-ui'

import Link from '@/components/atomic/link'
import { cn } from '@/utils/shadcn/utils'

export const LoginPageContainer: React.FC<
  React.PropsWithChildren & HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...props }) => {
  return (
    <section
      className={cn(
        'px-4 py-5.25',
        'min-h-[750px] h-screen',
        'bg-[linear-gradient(180deg,var(--color-surface-primary)_20%,var(--color-surface-secondary)_100%)] dark:bg-none dark:bg-(--color-surface-primary-contrast)',
        className,
      )}
      {...props}
    >
      {children}
    </section>
  )
}

export const LoginPageContent: React.FC<
  React.PropsWithChildren & HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...props }) => {
  return (
    <div
      className={cn(
        'h-full w-full max-w-[1220px]',
        'relative z-10',
        'mx-auto',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
}

export const FormContainer: React.FC<
  React.PropsWithChildren & HTMLAttributes<HTMLDivElement>
> = ({ children, ...props }) => {
  return (
    <div
      className={cn('mt-38.75', 'w-full', 'flex flex-col items-center')}
      {...props}
    >
      <div className="w-full max-w-[410px] flex flex-col items-center">
        {children}
      </div>
    </div>
  )
}

export const PrivacyPolicy: React.FC = () => {
  return (
    <div className={cn('absolute right-0 bottom-0')}>
      <Link route="https://moment.com/privacy-policy" className="group">
        <Text
          variant="mono"
          className={cn(
            'text-(--color-text-tertiary) dark:text-(--color-text-secondary-contrast)',
            'group-hover:text-(--color-text-secondary)/70 dark:group-hover:text-(--color-text-primary-contrast)/70',
            'transition-colors duration-250 ease',
          )}
        >
          Privacy Policy
        </Text>
      </Link>
    </div>
  )
}
